export enum PlaceStatus {
  Pending,
  Failed,
  Confirmed,
  Confirmed_Warning
}
